export const detectTextDirection = (text: string): string => {
    if (!text) return 'ltr';

    // Unicode ranges for RTL characters
    const rtlCharPattern = /[\u0591-\u07FF\uFB1D-\uFDFD\uFE70-\uFEFC]/g; // Hebrew, Arabic, etc.

    // Count RTL characters
    const rtlMatches = text.match(rtlCharPattern);
    const rtlCount = rtlMatches ? rtlMatches.length : 0;

    // Count total alphabetic characters (basic approximation for LTR)
    const alphabeticCharPattern = /[a-zA-Z]/g;
    const ltrMatches = text.match(alphabeticCharPattern);
    const ltrCount = ltrMatches ? ltrMatches.length : 0;

    return rtlCount > ltrCount ? 'rtl' : 'ltr';
}
